import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

const chevronLeft = <FontAwesomeIcon icon={faChevronLeft} />

function Navigation(props) {
  return(
    <div className="navigation">
      <div className="row">
        <div className="col prev">
          <Link to={'/' + props.prevStep}>
            {chevronLeft}{props.prev}
          </Link>
        </div>
        <div className="col next"></div>
      </div>
    </div>
  )
}

export default Navigation